module.exports = __webpack_public_path__ + "static/media/acne.f8ba4a8f.svg";